import { CATEGORIES } from "../../constants";

function CategoryPill({ catId, small, selected, onClick }) {
  const cat = CATEGORIES.find((c) => c.id === catId);
  if (!cat) return null;
  return (
    <span
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: small ? 3 : 5,
        padding: small ? "2px 8px" : "4px 10px",
        borderRadius: 20,
        fontSize: small ? 10 : 11,
        fontWeight: 600,
        background: selected ? cat.color + "44" : cat.color + "22",
        color: cat.color,
        border: `1px solid ${selected ? cat.color : cat.color + "44"}`,
        letterSpacing: "0.02em",
        textTransform: "uppercase",
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s ease",
      }}
    >
      <span style={{ fontSize: small ? 10 : 12 }}>{cat.icon}</span>
      {cat.label}
    </span>
  );
}

function ItemRow({ item, index, onUpdate, onRemove }) {
  const toggleCategory = (catId) => {
    const categories = item.categories || [];
    const newCategories = categories.includes(catId)
      ? categories.filter((c) => c !== catId)
      : [...categories, catId];
    onUpdate(index, { categories: newCategories });
  };

  return (
    <div
      style={{
        background: "#16162a",
        border: "1px solid #252545",
        borderRadius: 12,
        padding: 16,
        marginBottom: 12,
      }}
    >
      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        {/* Item name */}
        <div style={{ flex: 1 }}>
          <input
            type="text"
            value={item.name}
            onChange={(e) => onUpdate(index, { name: e.target.value })}
            placeholder="Item name"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #333",
              background: "#12122a",
              color: "#F0F0F0",
              fontSize: 14,
              fontFamily: "'DM Sans', sans-serif",
              outline: "none",
            }}
          />
        </div>

        {/* Quantity */}
        <div style={{ width: 70 }}>
          <input
            type="number"
            min="1"
            value={item.quantity}
            onChange={(e) => onUpdate(index, { quantity: parseInt(e.target.value) || 1 })}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #333",
              background: "#12122a",
              color: "#F0F0F0",
              fontSize: 14,
              fontFamily: "'DM Sans', sans-serif",
              textAlign: "center",
              outline: "none",
            }}
          />
        </div>

        {/* Remove button */}
        <button
          onClick={() => onRemove(index)}
          style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            border: "1px solid #E8927C44",
            background: "#E8927C11",
            color: "#E8927C",
            fontSize: 18,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {"\u2715"}
        </button>
      </div>

      {/* Options row */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
            color: "#888",
            fontSize: 13,
          }}
        >
          <input
            type="checkbox"
            checked={item.is_consumable || false}
            onChange={(e) => onUpdate(index, { is_consumable: e.target.checked })}
            style={{ accentColor: "#7ECEC1" }}
          />
          Consumable
        </label>
      </div>

      {/* Categories */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {CATEGORIES.map((cat) => (
          <CategoryPill
            key={cat.id}
            catId={cat.id}
            small
            selected={(item.categories || []).includes(cat.id)}
            onClick={() => toggleCategory(cat.id)}
          />
        ))}
      </div>
    </div>
  );
}

export default function ItemReview({
  items,
  containerName,
  onUpdateItem,
  onRemoveItem,
  onAddItem,
  onUpdateContainerName,
}) {
  return (
    <div style={{ padding: "20px 0" }}>
      {/* Container name */}
      <div style={{ marginBottom: 20 }}>
        <label style={{ display: "block", color: "#888", fontSize: 12, marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Container Name
        </label>
        <input
          type="text"
          value={containerName}
          onChange={(e) => onUpdateContainerName(e.target.value)}
          placeholder="e.g., Plumbing Tools"
          style={{
            width: "100%",
            padding: "12px 14px",
            borderRadius: 10,
            border: "2px solid #F0C75E44",
            background: "#12122a",
            color: "#F0F0F0",
            fontSize: 16,
            fontWeight: 600,
            fontFamily: "'DM Sans', sans-serif",
            outline: "none",
          }}
        />
      </div>

      {/* Items header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h3 style={{ margin: 0, color: "#F0F0F0", fontSize: 14, fontWeight: 700 }}>
          Items ({items.length})
        </h3>
        <button
          onClick={onAddItem}
          style={{
            padding: "6px 12px",
            borderRadius: 8,
            border: "1px solid #7ECEC144",
            background: "#7ECEC111",
            color: "#7ECEC1",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          + Add Item
        </button>
      </div>

      {/* Items list */}
      {items.length === 0 ? (
        <div
          style={{
            padding: 40,
            textAlign: "center",
            color: "#666",
            background: "#12122a",
            borderRadius: 12,
            border: "1px dashed #333",
          }}
        >
          <div style={{ fontSize: 32, marginBottom: 8 }}>{"\u{1F4E6}"}</div>
          <div>No items yet. Add some manually or retake the photo.</div>
        </div>
      ) : (
        <div>
          {items.map((item, index) => (
            <ItemRow
              key={index}
              item={item}
              index={index}
              onUpdate={onUpdateItem}
              onRemove={onRemoveItem}
            />
          ))}
        </div>
      )}

      {/* Summary */}
      {items.length > 0 && (
        <div
          style={{
            marginTop: 16,
            padding: "12px 16px",
            background: "#1a1a3e",
            borderRadius: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ color: "#888", fontSize: 13 }}>
            {items.length} item{items.length !== 1 ? "s" : ""} total
          </span>
          <span style={{ color: "#666", fontSize: 12 }}>
            {items.filter((i) => i.is_consumable).length} consumable
          </span>
        </div>
      )}
    </div>
  );
}
